import { render, staticRenderFns } from "./Vehicle.vue?vue&type=template&id=d56e430a&lang=pug&"
import script from "./Vehicle.vue?vue&type=script&lang=ts&"
export * from "./Vehicle.vue?vue&type=script&lang=ts&"
import style0 from "./Vehicle.vue?vue&type=style&index=0&id=d56e430a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports